import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { gearOrderDetails } from "../../utils/processesOrderDetails";

import MembershipCTA from "../../sections/membership-cta";
import CheckoutProgressHero from "../../sections/checkout-progress-hero";
import InStoreConfirmation from "../../sections/checkout-in-store-confirmation";
import CheckoutOnlineConfirmation from "../../sections/checkout-online-confirmation";

import { canUseDOM } from "../../utils";
import { selectUserState, selectCartItemsState, selectSessionId } from "../../selectors/application";
import { contactInfoSelector, isMemberSelector } from "../../selectors/gears-checkout";
import { getGearsProgressBars } from "../../services/gearsCheckoutService";

import { setSessionIdAction, clearCartItemsFromStorage } from "../../redux/actions/actions";
import { clearBillingInfoAction, clearContactInfoAction, clearShippingInfoAction } from "../../redux/actions/gears-checkout";
import { clearCart, getCart } from "../../services/cartService";
import useQuery from "../../utils/useQuery";
import { authProvider } from "../../services/authProvider";
import store from "../../redux/store/store";

const OrderConfirmation = props => {
  const { fields, lang, user, sessionId } = props;
  const { progressBar, selectedBar, backgroundImage, barHeading, barSubHeading } = fields;
  const [barProps, setBarProps] = useState({ steps: [] });
  // const [isInstore, setIsInstore] = useState(false);
  const query = useQuery();
  const orderId = canUseDOM() ? query.orderId : "";
  const queryInStore = canUseDOM() ? query.inStore : "";

  const measurements = async () => {
    const { orderDetail } = await gearOrderDetails({
      orderId: orderId,
      orderFields: props.fields.orderFields,
      lang: lang,
      inStore: queryInStore
    });
    /* Measurement */
    let dataLayer = window.dataLayer || [];
    let transaction = {
      id: orderId,
      affiliation: document.location.hostname,
      revenue: orderDetail?.grandTotal,
      tax: orderDetail?.tax,
      shipping: orderDetail?.shipping,
      coupon: orderDetail?.couponCode
    };
    let products = [];
    if (orderDetail?.suborders) {
      orderDetail.suborders.forEach(item => {
        item.orderItems.forEach(orderItem => {
          let product = {
            name: orderItem.spuName,
            id: orderItem.skuId,
            price: orderItem.paymentAmt,
            quantity: orderItem.qty,
            brand: orderItem.brandName && orderItem.brandName.toLowerCase().replace(/ /g, "-")
          };
          products.push(product);
        });
      });
    }

    dataLayer.push({
      event: "purchase",
      transaction: transaction,
      products: products
    });
  };

  useEffect(() => {
    clearShoppingCart().then();
    getGearsProgressBars(progressBar, selectedBar).then(value => {
      if (value) setBarProps(value);
    });
    measurements();
  }, []);
  const clearShoppingCart = async () => {
    let currentShoppingCart = await getCart(lang);
    let skuListToremove = [];
    if (currentShoppingCart.obj && currentShoppingCart.obj.skuList) {
      currentShoppingCart.obj.skuList.forEach(item => {
        skuListToremove.push({ skuCount: item.skuCount, skuId: item.skuId });
      });
    }
    if (skuListToremove.length > 0) {
      await clearCart(skuListToremove, user?.userAccount, sessionId);
    }
  };
  const hero = {
    backgroundImage: backgroundImage.value?.src,
    heading: barHeading.value,
    subHeading: barSubHeading.value,
    progressBar: {
      withOpacity: true,
      ...barProps
    }
  };

  return (
    <>
      {canUseDOM() && (
        <AzureAD provider={authProvider} reduxStore={store}>
          {({ accountInfo, authenticationState }) => {
            return (
              <>
                {authenticationState === AuthenticationState.Unauthenticated && <CheckoutOnlineConfirmation {...{ ...props, accountInfo, orderId, hero, queryInStore }} />}
                {authenticationState === AuthenticationState.Authenticated && (
                  <InStoreConfirmation
                    {...{
                      ...props,
                      accountInfo,
                      hero,
                      orderId
                    }}
                  />
                )}
              </>
            );
          }}
        </AzureAD>
      )}
    </>
  );
};

OrderConfirmation.propTypes = {
  hero: PropTypes.shape(CheckoutProgressHero.propTypes),
  listHeading: PropTypes.shape({
    heading: PropTypes.string,
    body: PropTypes.string
  }),
  orderNo: PropTypes.string,
  items: PropTypes.shape({
    title: PropTypes.string,
    itemList: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        quantity: PropTypes.number
      })
    )
  }),
  contentRows: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.string
    })
  ),
  shippingAdress: PropTypes.shape({
    title: PropTypes.string,
    lines: PropTypes.arrayOf(PropTypes.string)
  }),
  contactInfo: PropTypes.shape({
    title: PropTypes.string,
    lines: PropTypes.arrayOf(PropTypes.string)
  }),
  membershipInfo: PropTypes.shape(MembershipCTA.propTypes)
};

const mapDispatchToProps = dispatch => ({
  setSessionId: sessionId => dispatch(setSessionIdAction(sessionId)),
  clearCartItemsFromStorage: () => dispatch(clearCartItemsFromStorage()),
  clearBillingInfo: () => dispatch(clearBillingInfoAction()),
  clearShippingInfo: () => dispatch(clearShippingInfoAction()),
  clearContactInfo: () => dispatch(clearContactInfoAction())
});
const mapStateToProps = state => ({
  user: selectUserState(state),
  isMember: isMemberSelector(state),
  contactFormData: contactInfoSelector(state),
  cartItems: selectCartItemsState(state),
  sessionId: selectSessionId(state)
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderConfirmation));
